import * as React from "react";
import FlexContainer from "../grid/flexcontainer";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const revoCardClass = css({
    borderRadius: "5px",
    overflow: "hidden",
    border: `1px solid ${getThemeColorVar("border", "default")}`,
    backgroundColor: getThemeColorVar("white", undefined),
});
const revoCardHeaderClass = css({
    borderBottom: `1px solid ${getThemeColorVar("border", "default")}`,
});
const revoCardFooterClass = css({
    borderTop: `1px solid ${getThemeColorVar("border", "default")}`,
});
export const RevoCard = (props) => {
    const { header, footer, children } = props;
    return (React.createElement("div", { className: cx(revoCardClass) },
        React.createElement(FlexContainer, { direction: "col" },
            header && (React.createElement("div", { className: cx(revoCardHeaderClass) },
                React.createElement(FlexContainer, { canGrow: false, paddingX: "xxl", paddingY: "xxl" }, header))),
            React.createElement(FlexContainer, { paddingX: "xxl", paddingY: "xxl", direction: "col" }, children),
            footer && (React.createElement("div", { className: cx(revoCardFooterClass) },
                React.createElement(FlexContainer, { canGrow: false, canShrink: false, paddingX: "xxl", paddingY: "xxl" }, footer))))));
};
export default RevoCard;
//# sourceMappingURL=revo-card.js.map